import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=b32f081a&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"
import style0 from "./Initial.vue?vue&type=style&index=0&id=b32f081a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f081a",
  null
  
)

export default component.exports